var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-alert text-center"},[_c('small',[_c('b-icon',{attrs:{"icon":"emoji-frown","font-scale":"1.2"}}),_vm._v(" "),_c('b',[_vm._v(" Ci dispiace!")]),_vm._v(" "),_c('br'),_vm._v("Non ci sono "+_vm._s(_vm.type)+" per questi filtri.")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }